var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRooms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.997,
    height: 36.602,
    viewBox: "0 0 49.997 36.602",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_6570723_class_learning_from_home_education_icon",
    "data-name": "6570723_class_learning_from_home_education_icon",
    transform: "translate(-4.49 -72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M48.777,89.475a6.971,6.971,0,0,0-3.14-13.2h-.132V74.456A2.461,2.461,0,0,0,43.047,72H6.949A2.461,2.461,0,0,0,4.49,74.456V98.106a2.461,2.461,0,0,0,2.459,2.457h12.8v7h-4.2a.507.507,0,0,0,0,1.014h23.11a3.227,3.227,0,0,0,3.224-3.224V97.284a.507.507,0,0,0-1.014,0v8.066a2.216,2.216,0,0,1-2.216,2.216H28.336a3.534,3.534,0,0,1,3.491-3.021h5.189a.507.507,0,0,0,.507-.507v-3.855a.529.529,0,0,0,.016-.126.521.521,0,0,0-.016-.125V96.918a6.7,6.7,0,0,1,6.693-6.693h2.567a6.7,6.7,0,0,1,6.69,6.693v11.153a.507.507,0,1,0,1.014,0V96.918A7.72,7.72,0,0,0,48.777,89.475Zm2.82-6.223a5.963,5.963,0,1,1-5.963-5.963A5.963,5.963,0,0,1,51.6,83.251ZM5.5,98.106V96.959h31v2.59H6.949A1.44,1.44,0,0,1,5.5,98.106Zm10.048-11.65A2.759,2.759,0,1,1,18.31,83.7a2.759,2.759,0,0,1-2.758,2.758Zm.946,1.014a5.109,5.109,0,0,1,3.809,1.567l2.6,2.576a.5.5,0,0,0,.381.146.506.506,0,0,0,.365-.183l2.835-3.429a.7.7,0,0,1,1.085.886L23.757,93.76a.725.725,0,0,1-1.066.069l-2.613-2.5a.506.506,0,0,0-.856.366v4.251h-8V90.709a3.244,3.244,0,0,1,3.241-3.24Zm4.261,20.1v-7h6.787v5.864a.534.534,0,0,0,.009.09,4.492,4.492,0,0,0-.246,1.048Zm11.067-4.035a4.53,4.53,0,0,0-3.263,1.388v-4.355h7.943v2.966Zm4.743-7.584H20.244V92.882l1.749,1.68a1.741,1.741,0,0,0,2.555-.164l3.819-4.728a1.7,1.7,0,0,0-.207-2.351l2.438-5.38a.507.507,0,1,0-.922-.419L27.239,86.9a1.7,1.7,0,0,0-1.529.606l-2.484,3-2.187-2.177a5.878,5.878,0,0,0-3.092-1.718,3.777,3.777,0,1,0-4.743.038,4.261,4.261,0,0,0-2.991,4.063v5.236H5.5V74.45a1.446,1.446,0,0,1,1.44-1.44h36.1A1.446,1.446,0,0,1,44.5,74.45v1.917a6.97,6.97,0,0,0-2.087,13.053,7.726,7.726,0,0,0-5.839,6.526Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M209.886,110.35H196.4a.507.507,0,0,0,0,1.014h13.482a.507.507,0,1,0,0-1.014Z",
    transform: "translate(-172.383 -34.539)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M314.356,138.46H312.4a.507.507,0,0,0,0,1.014h1.948a.507.507,0,1,0,0-1.014Z",
    transform: "translate(-276.854 -59.854)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M204.853,138.966a.507.507,0,0,0-.506-.507h-7.942a.507.507,0,0,0,0,1.014h7.942a.507.507,0,0,0,.506-.507Z",
    transform: "translate(-172.383 -59.854)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M287.258,166.57h-4.943a.507.507,0,0,0,0,1.014h4.943a.507.507,0,0,0,0-1.014Z",
    transform: "translate(-249.755 -85.17)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M200.174,166.57h-3.767a.507.507,0,0,0,0,1.014h3.767a.507.507,0,0,0,0-1.014Z",
    transform: "translate(-172.383 -85.17)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRooms);
export default __webpack_public_path__ + "static/media/rooms.96eaa441f0950d9fb4fd91d6283aa646.svg";
export { ForwardRef as ReactComponent };